import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  HostBinding,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'cpd-link-button',
  templateUrl: './link-button.component.html',
  styleUrls: ['./link-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkButtonComponent implements OnInit, OnChanges {
  @Input() text: string;
  @Input() href: string = null;

  @Input() fontSet = 'fal';
  @Input() fontIcon: string;
  @Input() iconSide: 'left' | 'right' = 'left';

  @Input() color: 'basic' | 'primary' | 'secondary' = 'basic';
  @Input() size: 'small' | 'medium' | 'large';
  @Input() disabled = false;
  @Input() type = 'button';
  @Input() btnClass: string;
  /**
   * Callers write aria-label on <cpd-link-button>, but the host is not the
   * control. Take it as an input and put it on the inner <button>, so an
   * icon-only button (Clear, delete) has a name (WCAG 4.1.2), and clear it
   * from the host, where it would be a label on an element with no role.
   */
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('aria-label') ariaLabel: string;
  /**
   * Read after `text` by a screen reader and not shown, so a row of
   * identical "Remove" buttons can say which one is which while the visible
   * label, and so the start of the name (2.5.3), stays the same.
   */
  @Input() hiddenText: string;
  @HostBinding('attr.aria-label') readonly hostAriaLabel = null;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = new EventEmitter<Event>();

  ngClass: any;

  ngOnInit() {
    this.calcNgClass();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.text && !changes.text.isFirstChange()) ||
      (changes.color && !changes.color.isFirstChange()) ||
      (changes.size && !changes.size.isFirstChange()) ||
      (changes.disabled && !changes.disabled.isFirstChange())
    ) {
      this.calcNgClass();
    }
  }

  calcNgClass() {
    this.ngClass = {
      disabled: this.disabled,

      'text-black': this.color === 'basic',
      'text-green': this.color === 'primary',
      'text-blue': this.color === 'secondary',
      'bg-transparent': true,

      responsive: this.size === undefined,
      small: this.size === 'small',
      medium: this.size === 'medium',
      large: this.size === 'large',

      'no-text': !this.text
    };
  }

  onClick(event: Event) {
    event.stopPropagation();
    this.click.emit(event);
    if (this.href) {
      this.goToExternalLink(this.href);
    }
  }

  private goToExternalLink(url: string) {
    window.open(url, '_blank');
  }
}
